export const CommonHelpersVue = {

    methods: {
        closeMenuMain() {
            $('.menu-left').removeClass('menu-left--mobile-open');
            $('.js-burger').removeClass('burger--open');
        },

        closeMenuPageMenu() {
            $('.menu__left').removeClass('menu__left--open');
            $('.menu__left-btn-open').removeClass('menu__left-btn-open--open');
        }
    }
};